<template>
    <van-popup v-model:show="show" :style="{
        minWidth: '100%',
        minHeight: '60%',
        background: 'transparent',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }">
        <div class="pop_container">
            <div class="close_icon">
                <img src="@/assets/close_bai.png" alt="" @click="close">
            </div>
            <div class="content">
                <div class="congratsText">{{ $t('misteryBox.congrats') }}</div>
                <img src="@/assets/themeThree/misteryGift.png" alt="gift card" style="width: 35%;" />
                <div class="claimText">{{ $t('misteryBox.claimedAmount') }} :<span>{{ 'R$ ' + rewardValue }}</span>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref } from 'vue'
interface DataItem {
    recharge: string,
    reward: string,
    turnover: string
}
const show = ref(false)

const rewardValue = ref(0)
const exchangeType = ref(0)
const open = (data: any) => {
    show.value = true
    rewardValue.value = data.reward
    exchangeType.value = data.exchangeType
}
const close = () => {
    show.value = false
}

defineExpose({
    open,
})

</script>
<style scoped>
.pop_container {
    background: rgb(10 14 42);
    box-shadow: inset 0px -2px 0px 0.25px rgb(51, 85, 221), inset 0px 2px 0px 0px rgb(55 114 135);
    padding: 15px;
    border-radius: 20px;
    /* height: 300px; */
    width: 290px;
}

.van-overlay {
    background-color: #000000bd
}

.close_icon {
    display: flex;
    justify-content: right;
}

.close_icon img {
    width: 25px;
    opacity: 0.5;
}

.content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.congratsText {
    padding: 5px 15px;
    font-size: 16px;
    color: rgb(255, 255, 255);
    line-height: 24px;
    display: flex;
    justify-content: center;
}

.claimText {
    padding: 10px;
    font-size: 14px;
    color: rgb(255, 255, 255);
    line-height: 20px;
}

.claimText span {
    color: #FFD49F;
}
</style>